import React from 'react';
import {
	BsFiletypePdf,
	BsFileEarmarkZip,
	BsFiletypeDoc,
	BsFiletypeXls,
	BsFiletypeJpg,
	BsFolderFill,
	BsFiletypePng,
	BsFiletypeCsv,
	BsFiletypeXlsx,
	BsFiletypeDocx,
	BsFileEarmark,
	BsFileEarmarkImage,
	BsFiletypeSvg,
	BsFiletypeGif,
	BsFiletypeTiff,
	BsFiletypeBmp,
	BsFiletypeMp4,
	BsFiletypeMov,
} from 'react-icons/bs';

import { mimeTypes } from './constants/mimeTypes';

const FILE_ICONS = {
	folder: {
		component: BsFolderFill,
		color: 'var(--bs-blue)',
	},
	jpg: {
		component: BsFiletypeJpg,
		color: 'var(--bs-pink)',
	},
	jpeg: {
		component: BsFiletypeJpg,
		color: 'var(--bs-pink)',
	},
	png: {
		component: BsFiletypePng,
		color: 'var(--bs-orange)',
	},
	xls: {
		component: BsFiletypeXls,
		color: 'var(--bs-green)',
	},
	csv: {
		component: BsFiletypeCsv,
		color: 'var(--bs-green)',
	},
	xlsx: {
		component: BsFiletypeXlsx,
		color: 'var(--bs-green)',
	},
	zip: {
		component: BsFileEarmarkZip,
		color: 'var(--bs-yellow-700)',
	},
	pdf: {
		component: BsFiletypePdf,
		color: 'var(--bs-red)',
	},
	doc: {
		component: BsFiletypeDoc,
		color: 'var(--bs-cyan)',
	},
	docx: {
		component: BsFiletypeDocx,
		color: 'var(--bs-cyan)',
	},
	svg: {
		component: BsFiletypeSvg,
		color: 'var(--bs-purple)',
	},
	gif: {
		component: BsFiletypeGif,
		color: 'var(--bs-purple)',
	},
	tiff: {
		component: BsFiletypeTiff,
		color: 'var(--bs-purple)',
	},
	bmp: {
		component: BsFiletypeBmp,
		color: 'var(--bs-purple)',
	},
	webm: {
		component: BsFileEarmarkImage,
		color: 'var(--bs-purple)',
	},
	mp4: {
		component: BsFiletypeMp4,
		color: 'var(--bs-indigo)',
	},
	mov: {
		component: BsFiletypeMov,
		color: 'var(--bs-cyan)',
	},
	default: {
		component: BsFileEarmark,
		color: 'var(--bs-grey-700)',
	},
};

export const getFileType = (type) => {
	// Handle special cases for common image types
	if (type === 'image/jpg') {
		return 'jpg';
	}

	// Special handling for common mismatches
	if (type === 'image/jpeg') {
		return 'jpeg';
	}

	// Handle other MIME types
	const extension = mimeTypes[type];

	// For unknown MIME types, try to extract from the type itself
	if (!extension && type) {
		// For types like 'image/png', extract 'png'
		const parts = type.split('/');
		if (parts.length === 2) {
			return parts[1];
		}
	}

	return extension || '';
};

export const getIconByFileType = (type, size, color) => {
	const fileIcon = FILE_ICONS[type] || FILE_ICONS.default;
	return React.createElement(fileIcon.component, {
		size: size || 25,
		color:
			color ||
			(FILE_ICONS[type] ? FILE_ICONS[type].color : FILE_ICONS.default.color),
	});
};
